import {
    Box,
    Button,
    Checkbox,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControlLabel,
    Skeleton,
    Stack
} from '@mui/material';
import React from 'react';

const SignatureOnBehalfSkeleton: React.FC = () => {
    return (
        <>
            <DialogTitle>
                <Skeleton width={180} height={32} />
            </DialogTitle>
            <DialogContent>
                <Box mb={2}>
                    <Stack direction="row" spacing={4}>
                        {/* Therapist Card Skeleton */}
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <Box
                                sx={{
                                    background: '#F5F7FF',
                                    borderRadius: '12px',
                                    width: 48,
                                    height: 48,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mb: 1,
                                }}
                            >
                                <Skeleton variant="circular" width={32} height={32} />
                            </Box>
                            <Box>
                                <Skeleton width={60} height={20} />
                                <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                                    <Skeleton width={40} height={18} />
                                    <Skeleton width={80} height={18} />
                                </Box>
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    <Skeleton width={70} height={18} />
                                    <Skeleton width={60} height={18} />
                                </Box>
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    <Skeleton width={70} height={18} />
                                    <Skeleton width={60} height={18} />
                                </Box>
                            </Box>
                        </Box>
                        <Divider orientation="vertical" flexItem />
                        {/* DOR Card Skeleton */}
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <Box
                                sx={{
                                    background: '#F5F7FF',
                                    borderRadius: '12px',
                                    width: 48,
                                    height: 48,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mb: 1,
                                }}
                            >
                                <Skeleton variant="circular" width={32} height={32} />
                            </Box>
                            <Box>
                                <Skeleton width={60} height={20} />
                                <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                                    <Skeleton width={40} height={18} />
                                    <Skeleton width={80} height={18} />
                                </Box>
                                <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                                    <Skeleton width={70} height={18} />
                                    <Skeleton width={60} height={18} />
                                </Box>
                                <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                                    <Skeleton width={70} height={18} />
                                    <Skeleton width={60} height={18} />
                                </Box>
                            </Box>
                        </Box>
                    </Stack>
                </Box>
                <Stack flexDirection={'column'} rowGap={1.5}>
                    <Skeleton variant="rectangular" height={56} sx={{ mb: 2, borderRadius: 1 }} />
                    <Skeleton variant="rectangular" height={56} sx={{ mb: 2, borderRadius: 1 }} />
                    <FormControlLabel
                        control={<Checkbox disabled />}
                        label={<Skeleton width={320} height={20} />}
                    />
                    <FormControlLabel
                        control={<Checkbox disabled />}
                        label={<Skeleton width={320} height={20} />}
                        sx={{ mt: 1 }}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button disabled>
                    <Skeleton width={60} />
                </Button>
                <Button variant="contained" disabled>
                    <Skeleton width={60} />
                </Button>
            </DialogActions>
        </>
    );
};

export default SignatureOnBehalfSkeleton; 